import React from "react";
import { stopImpersonation, impTargetName } from "@/lib/impersonation";
import { UserCog, LogOut } from "lucide-react";

export function ImpersonationBanner({ impersonator, targetName }) {
  if (!impersonator) return null;
  const name = targetName || impTargetName() || "this user";
  return (
    <div data-testid="impersonation-banner" className="sticky top-0 z-[110] w-full bg-[#F9C509] text-[#06060C] px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium">
      <UserCog className="h-4 w-4 shrink-0" />
      <span className="truncate">You're viewing as <strong>{name}</strong> — signed in by {impersonator.admin_name || "an admin"}.</span>
      <button data-testid="impersonation-exit" onClick={stopImpersonation} className="inline-flex items-center gap-1.5 rounded-full bg-[#06060C] text-white px-3 py-1 hover:bg-[#1c1c24] transition-colors shrink-0">
        <LogOut className="h-3.5 w-3.5" /> Exit
      </button>
    </div>
  );
}
